"use client"

import { useQuery } from "@tanstack/react-query"
import {
  listTenantNotificationPoliciesAction,
  type TenantNotificationView,
} from "@/server-actions/tenant-notification-policies"

export const tenantNotificationPoliciesQueryKey = ["notifications", "tenant-policies"] as const

export function useTenantNotificationPoliciesQuery() {
  return useQuery<TenantNotificationView[]>({
    queryKey: tenantNotificationPoliciesQueryKey,
    queryFn: async () => {
      const result = await listTenantNotificationPoliciesAction({})
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
